import { render, staticRenderFns } from "./Location-Form.vue?vue&type=template&id=9874a76e&scoped=true&"
import script from "./Location-Form.vue?vue&type=script&lang=js&"
export * from "./Location-Form.vue?vue&type=script&lang=js&"
import style0 from "./Location-Form.vue?vue&type=style&index=0&id=9874a76e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9874a76e",
  null
  
)

export default component.exports